import React from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

export type Props = {
  label: string
  secondaryText?: string
  onRemove?: () => void
  testId: string
}

export const RequiredFieldRow = ({
  label,
  secondaryText,
  onRemove,
  testId,
}: Props) => (
  <Stack
    display="flex"
    direction="row"
    gap="0 20px"
    flexWrap="wrap"
    px="18px"
    py="16px"
    alignItems="center"
    border="1px solid #e2e5ea"
    borderRadius="8px"
    justifyContent="space-between"
    mt={1}
    data-test-id={testId}
  >
    <Typography variant="subtitle1" fontSize="14px">
      {label}
    </Typography>

    {secondaryText && (
      <Typography variant="body2" color="text.secondary">
        {secondaryText}
      </Typography>
    )}

    {onRemove && (
      <Button
        variant="text"
        size="small"
        onClick={onRemove}
        data-test-id={`${testId}-remove`}
      >
        Remove
      </Button>
    )}
  </Stack>
)

RequiredFieldRow.displayName = 'RequiredFieldRow'
